import compile from "./compile";
export default compile;
